module.exports = __webpack_public_path__ + "img/Berries.b3779646.png";